export default "__VITE_ASSET__B35wo9ZA__"